module.exports = __webpack_public_path__ + "img/registro-relink.7717a35.jpg";